import { motion } from "framer-motion"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Footer from "../Components/Footer/Footer"
import PageTitle from "../Components/PageTitle/PageTitle"
import { useGlobalContext } from "../Context/GlobalContext"
import "./pages.css"

const Destination = () => {
  const navigate = useNavigate()
  const { state } = useLocation()

  const { coords, dimentions } = useGlobalContext()

  useEffect(() => {
    if (!state.destination) {
      navigate("/")
    }
  }, [state.destination, navigate])

  return (
    <motion.section
      transition={{
        duration: 0.65,
        ease: "circIn",
      }}
      exit={{ scale: 0.95 }}
    >
      <motion.section data-scroll-section className="destination">
        <motion.div
          initial={{
            top: coords.y,
            left: coords.x,
            width: dimentions.w,
            height: dimentions.h,
          }}
          animate={{ top: 0, left: 0, width: "100vw", height: "100vh" }}
          transition={{
            duration: 0.4,
            ease: "circIn",
            // ease: [0.17, 0.67, 0.83, 0.67],
          }}
          className="section-hero__bg-img"
        >
          <img src={state.destination.imageUrl} alt={state.destination.title} />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="container-fluid section-hero"
        >
          <h1 className="section-hero__title serif-2">
            {state.destination.title}
          </h1>
          <h2 className="section-hero__desc">{state.destination.excerpt}</h2>
        </motion.div>
      </motion.section>
      <motion.section data-scroll-section className="section-desc">
        <div className="container-fluid">
          <p className="section-desc__desc">{state.destination.desc1}</p>
          <p className="section-desc__desc">{state.destination.desc2}</p>
        </div>
      </motion.section>
      <PageTitle
        title="the Land of "
        span="Origins"
        subtitle="come and visit"
        reverse
      />
      <Footer />
    </motion.section>
  )
}

export default Destination
